import Popup from 'reactjs-popup';
import Select from 'react-select'
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import { useAuthState } from '../../../../../../Helper/Context';
import { useDispatch } from 'react-redux';
import { STPMPCBTestPostDataAPI } from '../../../../../../Redux/STPDashboardSlice/STPPreventiveWork/STPPreventiveMPCBTestSlice';


export default function STPMPCBTestDataPopup(props) {

    const { handleOnCloseClick, open, Flag, handleIsPost, rowData, } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()
    
    const [MPCBParameterTextField, setMPCBParameterTextField] = useState({
        mpcbParameter: Flag === 'Update' ? rowData.mpcbParameter : '',
        unit: Flag === 'Update' ? rowData.unit : '',
        resultValue: Flag === 'Update' ? rowData.resultValue : '',
    })

    const handleMPCBParameterTextField = (e) => {
        setMPCBParameterTextField({ ...MPCBParameterTextField, [e.target.name]: e.target.value })
    }

    const handlePost = () => {
        const data = {
            T_STP_MPCBTestID: Flag === 'Update' ? rowData.t_stP_MPCBTestID : '0',
            ResultValue: MPCBParameterTextField.resultValue,
            M_UserID: UserID,
            token: token,
            handleIsPost: handleIsPost,
            handleOnCloseClick: handleOnCloseClick,
        }
        dispatch(STPMPCBTestPostDataAPI({ data }))
    }


    return (

        <Popup
            open={open} closeOnDocumentClick={false} onClose={handleOnCloseClick}
        >
            <div className="location_mob_pop modal-dialog modal-dialog-scrollable modal-xl" style={{ alignItems: "center", justifyContent: 'center' }}>
                <div className="modal-content road_ward_modal">
                    <div className="modal-header pl-4 p-1">
                        <h4 className="modal-title" id="staticBackdropLabel">MPCB Test</h4>
                        <button onClick={handleOnCloseClick} className="btn-close m-1 mr-3" type="button" />
                    </div>
                    <div className="modal-body">
                        <div className='inner-modal-body'>
                            <div className="row details-row">
                                <div className="col-12 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>MPCB Parameter</b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="mpcbParameter"
                                            name='mpcbParameter'
                                            value={MPCBParameterTextField.mpcbParameter}
                                            onChange={(e) => handleMPCBParameterTextField(e)}
                                            disabled
                                        />

                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Unit</b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="unit"
                                            name='unit'
                                            value={MPCBParameterTextField.unit}
                                            onChange={(e) => handleMPCBParameterTextField(e)}
                                            disabled
                                        />

                                    </div>
                                </div>
                                <div className="col-12 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Result Value</b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="resultValue"
                                            name='resultValue'
                                            value={MPCBParameterTextField.resultValue}
                                            onChange={(e) => handleMPCBParameterTextField(e)}
                                        />

                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-12 pt-lg-5 pt-md-4 pt-3">
                                <div className="btn-action d-flex justify-content-end">
                                    <button type='button'
                                        className="btn allBtn  float-right submit_btn"
                                        onClick={() => handlePost()}
                                        disabled={
                                            MPCBParameterTextField.mpcbParameter == '' || MPCBParameterTextField.unit == '' ||
                                            MPCBParameterTextField.resultValue == '' 
                                        }
                                    >{Flag === "Update" ? "Update" : "Save"} </button>
                                    <button typtton type="button" className="btn addBtns cancel_btn ms-2 mr-2 mx-2  float-right" onClick={handleOnCloseClick} >Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* )} */}
        </Popup>
    )

}